import React, {ReactElement} from "react";
import {LoadingPlaceholder} from "@core-ui/loading-placeholder";
import {PlaceholderProps} from "./types";

export const DefaultPlaceholder = ({
  showColorSwatchesPlaceholder,
  showStarRatingsPlaceholder,
}: PlaceholderProps): ReactElement => (
  <div
    className="placeholder-grid__container"
    style={{
      float: "left",
      overflow: "hidden",
    }}
  >
    <div style={{paddingBottom: ".5rem"}}>
      <LoadingPlaceholder
        className="placeholder-grid__image"
        ratio={{width: 240, height: 321}}
      />
    </div>

    {showColorSwatchesPlaceholder && (
      <div style={{paddingBottom: ".5rem"}}>
        <LoadingPlaceholder fixedSize={{width: 234, height: 34}} />
      </div>
    )}

    <div style={{paddingBottom: ".5rem"}}>
      <LoadingPlaceholder fixedSize={{width: 140, height: 18}} />
    </div>

    {showStarRatingsPlaceholder && (
      <div style={{paddingBottom: ".5rem"}}>
        <LoadingPlaceholder fixedSize={{width: 115, height: 15}} />
      </div>
    )}

    <div style={{paddingBottom: ".5rem"}}>
      <LoadingPlaceholder fixedSize={{width: 60, height: 18}} />
    </div>

    <div>
      <LoadingPlaceholder fixedSize={{width: 120, height: 18}} />
    </div>
  </div>
);
